import React, { forwardRef } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

type CenteredProps = ViewProps & {
	children: React.ReactNode;
};

const Centered = forwardRef<View, CenteredProps>(({ children, style, ...props }, ref) => {
	return (
		<View ref={ref} style={[styles.centered, style]} {...props}>
			{children}
		</View>
	);
});

const styles = StyleSheet.create({
	centered: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

export default Centered;
